module.exports = __webpack_public_path__ + "static/media/Аннотации_1.c424405c.pdf";